export const setEntitlementsInStorage = (entitlements) => {
    try {
        localStorage.setItem('userEntitlements', JSON.stringify(entitlements));
    } catch (error) {
        console.error('Error saving entitlements to localStorage:', error);
    }
};

export const getEntitlementsFromStorage = () => {
    try {
        const entitlements = localStorage.getItem('userEntitlements');
        return entitlements ? JSON.parse(entitlements) : null;
    } catch (error) {
        console.error('Error retrieving entitlements from localStorage:', error);
        return null;
    }
};

export const clearEntitlementsFromStorage = () => {
    try {
        localStorage.removeItem('userEntitlements');
    } catch (error) {
        console.error('Error clearing entitlements from localStorage:', error);
    }
};
